import React, { lazy } from 'react';
import { ArrowRight, Lock, ShieldCheck, Download } from 'lucide-react';
export function FinalCTA() {
  return <section id="final-cta" className="py-24 pb-32 bg-dark-50 text-center" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4" data-id="element-2">
        <h2 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6" data-id="element-3">
          Take Back Your Financial Freedom
        </h2>
        <p className="text-xl text-gray-400 mb-10" data-id="element-4">
          The banks are betting you'll stay lazy and do nothing. Prove them
          wrong.
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-5">
          <div className="inline-block bg-danger/10 border border-danger/30 px-4 py-1 rounded-full mb-2" data-id="element-6">
            <span className="text-danger text-sm font-bold uppercase tracking-wider" data-id="element-7">
              🔥 Launch Special — Limited Time Only
            </span>
          </div>
          <div className="text-center mb-2" data-id="element-8">
            <span className="text-gray-500 line-through text-lg mr-3" data-id="element-9">$27</span>
            <span className="text-gold font-heading font-bold text-4xl" data-id="element-10">
              $6.39
            </span>
            <span className="text-gray-400 ml-2 text-sm" data-id="element-11">one-time</span>
          </div>

          <a href="https://financialsledge.com/cart/53082740883770:1" target="_blank" rel="noopener noreferrer" className="relative z-[60] inline-flex items-center justify-center font-heading font-bold uppercase tracking-wider transition-all duration-200 bg-gold hover:bg-gold-light text-black shadow-[0_0_20px_rgba(255,215,0,0.4)] hover:shadow-[0_0_35px_rgba(255,215,0,0.7)] cta-pulse px-12 py-5 text-xl md:text-2xl w-full md:w-auto rounded-sm cursor-pointer" data-id="element-12">
            Get The Sledgehammer Now
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-13" />
          </a>

          <div className="flex flex-wrap justify-center gap-4 mt-2" data-id="element-14">
            <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-15">
              <Lock className="w-3 h-3 text-trust" data-id="element-16" />
              <span data-id="element-17">Secure Checkout</span>
            </div>
            <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-18">
              <Download className="w-3 h-3 text-success" data-id="element-19" />
              <span data-id="element-20">Instant Download</span>
            </div>
            <div className="flex items-center gap-1 text-xs text-gray-400" data-id="element-21">
              <ShieldCheck className="w-3 h-3 text-success" data-id="element-22" />
              <span data-id="element-23">Quality Guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}